
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.5 12.8c-1.3 0-2.4 1.1-2.4 2.4v.4h-2.2v-.4c0-1.3-1.1-2.4-2.4-2.4-1.3 0-2.4 1.1-2.4 2.4 0 1.3 1.1 2.4 2.4 2.4h.4v8c0 .6.4 1 1 1s1-.4 1-1v-8h2.2v8c0 .6.4 1 1 1s1-.4 1-1v-8h.4c1.3 0 2.4-1.1 2.4-2.4 0-1.3-1.1-2.4-2.4-2.4zm-7 2.8c-.2 0-.4-.2-.4-.4s.2-.4.4-.4.4.2.4.4v.4h-.4zm7 0h-.4v-.4c0-.2.2-.4.4-.4s.4.2.4.4-.2.4-.4.4z","fill":"#F9A91E"}}),_c('path',{attrs:{"d":"M29.1 12.3C29.1 5.6 23.7.2 17 .2 10.3.2 4.9 5.6 4.9 12.3c0 3.9 1.9 7.5 5.1 9.8v4.2c0 .6.4 1 1 1h.5v2.6c0 .6.4 1 1 1h.7c.4 1.7 2 2.9 3.8 2.9 1.8 0 3.3-1.2 3.8-2.9h.7c.6 0 1-.4 1-1v-2.6h.5c.6 0 1-.4 1-1v-4.2c3.2-2.2 5.1-5.8 5.1-9.8zM17 31.8c-.7 0-1.3-.4-1.6-.9h3.2c-.3.5-.9.9-1.6.9zm3.5-2.9h-7v-1.6h7v1.6zm2-8.2c-.3.2-.5.5-.5.9v3.7H12v-3.7c0-.3-.1-.7-.4-.9-2.9-1.9-4.6-5-4.6-8.5-.1-5.5 4.4-10 10-10s10.1 4.5 10.1 10.1c0 3.5-1.8 6.7-4.6 8.4z","fill":"#47AEA6"}})])
          )
        }
      }
    